import React, { useState } from "react";
import { Box, useTheme } from "@mui/material";
import { InternalNavigation } from "./InternalNavigation";

export function InternalLayout({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", height: "100%" }}>
      <InternalNavigation
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minHeight: "100vh",
          transition: theme.transitions.create(["margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
